"use client";

import Image from "next/image";
import ExcellenceStack from "./ExcellenceStack";
import { EXCELLENCE_CARDS } from "@/constants/ContactData";

const topImage = "/assets/contact/top.webp";
const bottomImage = "/assets/contact/bottom.webp";

export default function ExcellenceSection({
  className = "",
  width = 1274,
  height = 552,
  label = "EXCELLENCE",
  isDark,
}) {
  return (
    <section
      className={`relative w-full max-w-[2000px] mx-auto lg:px-10 xl:px-16 laptop:px-24 2xl:px-28 3xl:px-28 4xl:px-32 ${className} touch-pan-y`}
      aria-label="Excellence Highlight"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-10 mobile:gap-36 sm:gap-36 md:gap-30 lg:gap-38 xl:gap-72 laptop:gap-[284px] 3xl:gap-84 4xl:gap-96 items-center">
        {/* Left vertical label */}
        <div className="grid grid-cols-1 mobile:grid-cols-2 gap-8 sm:gap-4 md:gap-0 lg:gap-[-16px] lg:mt-0 mt-10 ">
          <div className="flex justify-center lg:justify-start items-center mb-10 mobile:mb-0 mobile:pt-12 sm:pt-16 lg:pt-8">
            <h2 className="font-alexandria font-bold uppercase text-4xl mobile:text-[48px] sm:text-[56px] md:text-[70px] lg:text-[82px] 3xl:text-[96px] 4xl:text-[110px]  lg:[writing-mode:vertical-rl] rotate-0 mobile:rotate-270 lg:rotate-180 text-[#9C00BB] dark:text-white tracking-tight translate-x-0 mobile:-translate-x-10 sm:-translate-x-18 md:-translate-x-24 lg:translate-x-0">
              {label}
            </h2>
          </div>

          {/* Middle overlapping images */}
          <div className="relative lg:min-w-[340px] flex lg:justify-center lg:block">
            {/* Wrapper that scales proportionally */}
            <div className="relative w-full aspect-[320/240] mobile: flatter sm:aspect-[320/280] md:aspect-[374/400] lg:aspect-[374/552] xl:aspect-[420/600] 3xl:aspect-[460/640] 4xl:aspect-[500/700]">
              {/* Top image */}
              <div className="absolute -top-10 mobile:-top-4 sm:top-0 left-[30px] mobile:left-[-140px] sm:left-[-160px] lg:left-[-90px] xl:left-[-70px] w-[45%] mobile:w-[60%] md:w-[62%] lg:w-[66%] laptop:w-[248px] laptop:h-[359px] 3xl:w-[76%] 4xl:w-[80%] max-w-[260px] laptop:max-w-[248px] 3xl:max-w-[380px] 4xl:max-w-[440px] aspect-[248/359] rounded-lg overflow-hidden">
                <Image
                  src={topImage}
                  alt="Team session"
                  fill
                  className="object-cover rounded-lg transition-transform duration-500 hover:scale-105"
                  priority
                  sizes="(max-width: 479px) 45vw, 
                         (max-width: 639px) 60vw, 
                         (max-width: 1023px) 66vw, 
                         (max-width: 1439px) 248px, 
                         (max-width: 1799px) 380px, 
                         440px"
                  quality={90}
                  placeholder={
                    typeof topImage === "string" ? undefined : "blur"
                  }
                />
                <div className="absolute inset-0 dark:bg-black/50 rounded-lg transition-opacity duration-300 pointer-events-none"></div>
              </div>

              {/* Bottom image */}
              <div className="absolute left-[40%] mobile:-left-[10%] sm:left-[0%] xl:left-[20%] 3xl:left-[25%] 4xl:left-[28%] top-[40%] mobile:top-[50%] sm:top-[40%] xl:top-[48%] 3xl:top-[50%] 4xl:top-[52%] w-[50%] mobile:w-[75%] md:w-[78%] lg:w-[82%] laptop:w-[306px] laptop:h-[276px] 3xl:w-[92%] 4xl:w-[96%] max-w-[306px] laptop:max-w-[306px] 3xl:max-w-[440px] 4xl:max-w-[500px] aspect-[306/276] rounded-lg overflow-hidden shadow-lg">
                <Image
                  src={bottomImage}
                  alt="Workplace"
                  fill
                  className="object-cover rounded-lg transition-transform duration-500 hover:scale-105"
                  sizes="(max-width: 479px) 50vw, 
                         (max-width: 639px) 75vw, 
                         (max-width: 1023px) 82vw, 
                         (max-width: 1439px) 306px, 
                         (max-width: 1799px) 440px, 
                         500px"
                  quality={90}
                  placeholder={
                    typeof bottomImage === "string" ? undefined : "blur"
                  }
                />
                <div className="absolute inset-0 dark:bg-black/50 rounded-lg transition-opacity duration-300 pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Cards Stack */}
        <div className="flex justify-center">
          <ExcellenceStack
            items={EXCELLENCE_CARDS}
            className="w-full max-w-[620px] px-4 mobile:px-8 sm:px-10 md:px-12 lg:px-0"
          />
        </div>
      </div>
    </section>
  );
}
